export const getBaseUrls = (channelId) => ({
  cgeBaseUrl: process.env.REACT_APP_CGE_BASE_URL,
  scensumBaseUrl:
    process.env[`REACT_APP_SCENSUM_BASE_URL_CHANNEL_ID_${channelId}`],
});
